import { DataUtils } from "../utils/DataUtils";
const xhrModule = require('xhr');
export class HTTPError extends Error {
    constructor(status, message, response = null) {
        message = response && response.message ? response.message : message;
        super(message);
        this.message = message;
        this.code = response && response.code ? response.code : '';
        this.response = response;
        this.status = status;
    }
}
class API {
    constructor() {
        this._cache = {};
        this._calls = {};
        this._url = '';
        setInterval(() => {
            this.clearCache();
        }, 86400000);
    }
    set serverURL(url) {
        this._url = url;
    }
    clearCache(url = '') {
        logger.log('XHR.clearCache', url);
        if (url) {
            delete this._cache[url];
        }
        else {
            this._cache = {};
        }
    }
    abortCallSimple(urlPart) {
        if (urlPart) {
            for (let url in this._calls) {
                if (url.indexOf(urlPart) > -1) {
                    this.abortCall(url);
                }
            }
        }
    }
    abortAll() {
        logger.log('XHR.abortAll');
        for (let url in this._calls) {
            this.abortCall(url);
        }
    }
    isCalling(url) {
        return this._calls.hasOwnProperty(url);
    }
    abortCall(url) {
        if (this._calls[url]) {
            logger.warn('XHR.abortCall', url);
            if (this._calls[url].xhr && this._calls[url].xhr.abort) {
                this._calls[url].xhr.abort();
            }
            delete this._calls[url];
        }
        else {
            logger.warn('XHR.abortCall', 'no call found', url);
        }
    }
    get(url, data = null, options = null) {
        if (!options) {
            options = {};
        }
        const optionsParsed = {
            csrf: false,
            allowCache: DataUtils.isNone(options.allowCache) ? false : options.allowCache,
            json: DataUtils.isNone(options.json) ? true : options.json,
            jsonError: false,
            encodeURI: DataUtils.isNone(options.encodeURI) ? false : options.encodeURI,
            delay: options.delay && options.delay > 0 ? options.delay : 0
        };
        if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
            return this.call(url, data, 'GET', optionsParsed);
        }
        else {
            return this.call(this._url + url, data, 'GET', optionsParsed);
        }
    }
    put(url, data, options = null) {
        if (!options) {
            options = {};
        }
        const optionsParsed = {
            csrf: DataUtils.isNone(options.csrf) ? false : options.csrf,
            allowCache: false,
            jsonError: DataUtils.isNone(options.jsonError) ? true : options.jsonError,
            json: DataUtils.isNone(options.json) ? true : options.json,
            encodeURI: false,
        };
        if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
            return this.call(url, data, 'PUT', optionsParsed);
        }
        else {
            return this.call(this._url + url, data, 'PUT', optionsParsed);
        }
    }
    post(url, data = null, options = null) {
        if (!options) {
            options = {};
        }
        const optionsParsed = {
            csrf: DataUtils.isNone(options.csrf) ? true : options.csrf,
            allowCache: false,
            jsonError: DataUtils.isNone(options.jsonError) ? true : options.jsonError,
            json: DataUtils.isNone(options.json) ? true : options.json,
            encodeURI: false,
        };
        if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
            return this.call(url, data, 'POST', optionsParsed);
        }
        else {
            return this.call(this._url + url, data, 'POST', optionsParsed);
        }
    }
    delete(url, data = null, options = null) {
        if (!options) {
            options = { jsonError: true };
        }
        if (!options.hasOwnProperty('jsonError')) {
            options.jsonError = true;
        }
        if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
            return this.call(url, data, 'DELETE', options);
        }
        else {
            return this.call(this._url + url, data, 'DELETE', options);
        }
    }
    parseJSON(body) {
        try {
            return JSON.parse(body);
        }
        catch (e) {
            return body;
        }
    }
    call(url, data, method, options) {
        let self = this;
        let bodyData = null;
        if (options.csrf) {
            const field = document.querySelector('[name="csrfmiddlewaretoken"]');
            if (field) {
                data['csrfmiddlewaretoken'] = field.value;
            }
        }
        if (data) {
            if (method === 'GET') {
                const params = [];
                for (let param in data) {
                    params.push(param + '=' + (options.encodeURI ? encodeURIComponent(data[param]) : data[param]));
                }
                if (params.length > 0) {
                    const paramsStr = params.join('&');
                    if (url.indexOf('?') > -1) {
                        url += '&' + paramsStr;
                    }
                    else {
                        url += '?' + paramsStr;
                    }
                    url = url;
                }
            }
            else {
                if (options.json) {
                    bodyData = JSON.stringify(data);
                }
                else {
                    bodyData = new FormData();
                    for (let param in data) {
                        bodyData.append(param, data[param]);
                    }
                }
            }
        }
        let call = this._calls[url];
        if (call && method === 'GET') {
            return call.loader || Promise.reject(new Error('null error'));
        }
        else {
            call = { xhr: null, loader: null };
            this._calls[url] = call;
            let loader = new Promise((resolve, reject) => {
                if (options.allowCache && self._cache.hasOwnProperty(url)) {
                    this._cache[url].fromCache = true;
                    delete this._calls[url];
                    resolve(this._cache[url]);
                }
                else {
                    const headers = {};
                    if (options.csrf) {
                        const token = DataUtils.getCookie("csrftoken");
                        if (token) {
                            headers['X-CSRFToken'] = token;
                        }
                    }
                    if (options.json) {
                        headers['Accept'] = "application/json";
                    }
                    const parsedData = {
                        body: bodyData,
                        uri: url,
                        method: method,
                        headers: headers,
                        withCredentials: true
                    };
                    if (options.delay && options.delay > 0) {
                        setTimeout(() => {
                            this.xhrCall(parsedData, url, method, call, options).then((data) => {
                                resolve(data);
                            }).catch((error) => {
                                reject(error);
                            });
                        }, options.delay);
                    }
                    else {
                        this.xhrCall(parsedData, url, method, call, options).then((data) => {
                            resolve(data);
                        }).catch((error) => {
                            reject(error);
                        });
                    }
                }
            });
            if (call) {
                call.loader = loader;
            }
            return loader;
        }
    }
    xhrCall(data, url, method, call, options) {
        return new Promise((resolve, reject) => {
            if (this._calls[url]) {
                let xhr = xhrModule(data, (err, resp, body) => {
                    let result = null;
                    delete this._calls[url];
                    if (!err && ((resp.statusCode >= 200 && resp.statusCode < 300) || resp.statusCode === 304)) {
                        result = {
                            fromCache: false,
                            body: this.parseJSON(body),
                            statusCode: resp.statusCode
                        };
                        if (method === 'GET') {
                            this._cache[url] = result;
                        }
                        resolve(result);
                    }
                    else {
                        if (err) {
                            reject(new HTTPError(599, err.message));
                        }
                        else {
                            reject(new HTTPError(resp.statusCode, `http status ${resp.statusCode}`, options.jsonError ? this.parseJSON(body) : body));
                        }
                    }
                });
                call.xhr = xhr;
            }
        });
    }
}
export const api = new API();
